import { Outlet } from 'react-router'

const DealsMainLayout = () => {
  return (
    <Outlet />
  )
}

export default DealsMainLayout